// extracted by mini-css-extract-plugin
export default {"root":"App_root__40Hjl","heroImage":"App_heroImage__ujtXf","brand-name":"App_brand-name__BKikz","cardContainer":"App_cardContainer__5M2I6","cardTitle":"App_cardTitle__clYGt"};